import { Injectable } from '@angular/core';
import { Entry } from 'contentful';
import { DataService } from './data.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';


@Injectable()
export class ContentfulService {

  constructor(private dataService: DataService, private http: HttpClient) { }

  /** Function to get information about the space **/
  getLocales(): Promise<any> {
    const locales = {
      sys: { type: 'Array' },
      total: 4,
      skip: 0,
      limit: 1000,
      items: [
        {
          code: 'af-ZA',
          name: 'Afrikaans (South Africa)',
          default: false,
          fallbackCode: 'en-US',
          sys: { id: '66saOOFANDaPvagpZws5av', type: 'Locale', version: 1 },
          flag: 'ZA.svg',
        },
        {
          code: 'en-US',
          name: 'English (United States)',
          default: true,
          fallbackCode: null,
          sys: { id: '4ieZtbZ4ogUqdv61nyDZgW', type: 'Locale', version: 1 },
          flag: 'US.svg',
        },
        {
          code: 'pt-BR',
          name: 'Portuguese (Brazil)',
          default: false,
          fallbackCode: 'en-US',
          sys: { id: '2Jm0geK9EZ31obx1jI5c1v', type: 'Locale', version: 4 },
          flag: 'BR.svg',
        },
        {
          code: 'es-ES',
          name: 'Spanish (Spain)',
          default: false,
          fallbackCode: 'en-US',
          sys: { id: '4ihUsxufTUnW5Eiusjv0Zc', type: 'Locale', version: 2 },
          flag: 'ES.svg',
        },
      ],
    };
    return new Promise((resolve, reject) => {
      resolve(locales);
    });
  }

  /** Function to observe to content and update accordingly if there is a change to the language of the user **/
  getAndObserveContent(contentType): Observable<Entry<any>[]> {
    return new Observable<Entry<any>[]>((observer) => {
      // First pass is to get the entries based off the current locale and content_type requested
      // But only do this if the locales have been fetched already
      if (this.dataService.languages.length !== 0) {
        this.getEntries(contentType, observer);
      }
      // Second pass is to subscribe to the event emitter that the selected language has changed, therefore need to update
      // all the relevant subscriber's content
      this.dataService.languageChange.subscribe(() => {
        this.getEntries(contentType, observer);
      });
    });
  }

  public getLocalJson(contentType): Promise<any> {
    return this.http.get(`./assets/downloaded_locales/${this.dataService.selectedLanguage.code}-${contentType}.json`).toPromise();
  }

  /** Function to make the api call to get the entries from contentful and update the observer **/
  getEntries(contentType, observer) {
    this.getLocalJson(contentType)
      .then((res) => {
        return observer.next(res);
      })
      .catch(err => console.log('Error', err));
  }
}
